import { useNavigate } from "react-router-dom";
import { BookOpen, Github, Twitter, Linkedin } from "lucide-react";

export function Footer() {
    const navigate = useNavigate();

    return (
        <footer className="w-full bg-slate-950 border-t border-slate-900 py-12 mt-20">
            <div className="max-w-6xl mx-auto px-6">
                <div className="grid md:grid-cols-4 gap-8 mb-12">
                    <div className="col-span-1 md:col-span-2 space-y-4">
                        <div className="flex items-center gap-2 text-white font-bold text-xl">
                            <BookOpen className="w-6 h-6 text-brand-primary" />
                            <span>EMI Universal</span>
                        </div>
                        <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
                            The next generation of interactive reading. Transform any document into an immersive experience with zero latency and complete privacy.
                        </p>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-4">Platform</h4>
                        <ul className="space-y-2 text-sm text-slate-400">
                            <li onClick={() => navigate('/')} className="hover:text-brand-primary cursor-pointer transition-colors">Home Library</li>
                            <li className="hover:text-brand-primary cursor-pointer transition-colors">Features</li>
                            <li className="hover:text-brand-primary cursor-pointer transition-colors">Premium</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-4">Company</h4>
                        <ul className="space-y-2 text-sm text-slate-400">
                            <li onClick={() => navigate('/about')} className="hover:text-brand-primary cursor-pointer transition-colors">About Us</li>
                            <li onClick={() => navigate('/privacy')} className="hover:text-brand-primary cursor-pointer transition-colors">Privacy Policy</li>
                            <li onClick={() => navigate('/contact')} className="hover:text-brand-primary cursor-pointer transition-colors">Contact Support</li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 border-t border-slate-900 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500">
                    <p>© 2026 EMI Universal Reader. All rights reserved.</p>
                    <div className="flex gap-6">
                        <Github className="w-4 h-4 hover:text-white cursor-pointer transition-colors" />
                        <Twitter className="w-4 h-4 hover:text-white cursor-pointer transition-colors" />
                        <Linkedin className="w-4 h-4 hover:text-white cursor-pointer transition-colors" />
                    </div>
                </div>
            </div>
        </footer>
    );
}
